import { useFormik } from "formik";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { addModule, editModule, getSingleModule } from "../../redux/services/moduleSlice";
import { fileUpload } from "../../redux/services/fileUploadSlice";
import { ROUTES } from "../../constant";
import { getCourses } from "../../redux/services/courseSlice";
import { Select } from "antd";

const ModuleForm = ({ action }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const singleModule = useSelector((state) => state.module.singleModuleData);
  const CourseData = useSelector((state) => state?.course?.courseData?.course_data);
  console.log("CourseData", CourseData);
  const queryParams = new URLSearchParams(location.search);
  const moduleId = queryParams.get("moduleId");

  const [loading, setLoading] = useState(false);
  const [preview, setPreview] = useState(null);

  const initialValues = {
    courseIds: [],
    name: "",
    subTitle: "",
    totalLecture: "",
    totalTest: "",
    priority: null,
    image: "",
    link: "",
  };

  const validationSchema = Yup.object({
    // courseIds: Yup.array().required("Course is required"),
    name: Yup.string().required("Name is required"),
    subTitle: Yup.string().required("Subtitle is required"),
    totalLecture: Yup.number().required("Total Lecture is required"),
    priority: Yup.number().required("Priority is required"),
    totalTest: Yup.number().required("Total Test is required"),
    image: Yup.string().required("Image is required"),
  });

  const onSubmit = async (values, { resetForm }) => {
    setLoading(true);
    try {
      if (moduleId) values.moduleId = moduleId;

      const response = moduleId ? await dispatch(editModule(values)) : await dispatch(addModule(values));

      if (response?.payload?.status === 200) {
        toast.success(response?.payload?.message);
        navigate(ROUTES.COURSES.MODULE);
        resetForm();
      }
    } catch (error) {
      toast.error("Error saving module");
    } finally {
      setLoading(false);
    }
  };

  // const { values, errors, touched, handleChange, handleBlur, handleSubmit, setValues } = useFormik({ initialValues, validationSchema, onSubmit });
  const { values, errors, touched, handleChange, handleBlur, handleSubmit, setValues, setFieldValue } =
    useFormik({ initialValues, validationSchema, onSubmit });
  const getSingleRecord = useCallback(async () => {
    if (moduleId) await dispatch(getSingleModule(moduleId));
  }, [dispatch, moduleId]);

  useEffect(() => {
    if (moduleId) getSingleRecord();
  }, [getSingleRecord]);

  const getAllCourses = useCallback(async () => {
    try {
      await dispatch(getCourses({}));
    } catch (error) { }
  }, [dispatch]);

  useEffect(() => {
    getAllCourses();
  }, [getAllCourses]);

  useEffect(() => {
    if (moduleId && singleModule) {
      setValues({
        courseIds: singleModule?.courseIds ?? "",
        name: singleModule?.name ?? "",
        subTitle: singleModule?.subTitle ?? "",
        totalLecture: singleModule?.totalLecture ?? "",
        priority: singleModule?.priority ?? "",
        totalTest: singleModule?.totalTest ?? "",
        image: singleModule?.image ?? "",
        link: singleModule?.link ?? "",
      });
      setPreview(singleModule?.image ?? null);
    }
  }, [moduleId, singleModule, setValues]);

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append("image", file);
    try {
      setLoading(true);
      const response = await dispatch(fileUpload(formData));
      const url = response.payload?.fileUrl || response.payload;
      setValues({ ...values, image: url });
      setPreview(url);
      toast.success("Image uploaded successfully!");
    } catch {
      toast.error("Image upload failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-background py-4 sm:py-4">
      <div className="px-4 md:py-10 py-5 bg-card shadow rounded-3xl sm:p-10">
        <p className="md:text-3xl text-xl text-center font-medium uppercase text-primary">{action} Module</p>
        <form onSubmit={handleSubmit} className="mt-6 grid md:grid-cols-2 grid-cols-1 gap-5 antForm">
          {/* <div className="md:col-span-2">
            <label className="text-sm font-medium text-foreground">Select Course</label>
            <select name="courseIds" value={values.courseIds} onChange={handleChange} onBlur={handleBlur} className="w-full px-4 py-2 border border-border rounded-xl">
              <option value="">Select Course</option>
              {CourseData?.map((course) => (
                <option key={course._id} value={course._id}>
                  {course.title}
                </option>
              ))}
            </select>
            {touched.courseIds && errors.courseIds && <div className="text-red-500 text-sm">{errors.courseIds}</div>}
          </div> */}
          {/* <div className="md:col-span-2">
            <label className="block font-medium mb-1">Select Courses *</label>
            <Select
              mode="multiple"
              name="courseIds"
              value={values.courseIds}
              // onChange={(v) => handleSelectChange("courseIds", v)}
              onChange={handleChange}
              options={CourseData?.map((c) => ({
                value: c._id,
                label: c.title,
              }))}
              placeholder="Select course(s)"
              style={{ width: "100%" }}
            /> */}
          {/* {errors.courseIds && <p className="text-red-500 text-sm">{errors.courseIds}</p>} */}
          {/* </div> */}
          <div className="md:col-span-2">
            <label className="block font-medium mb-1">Select Courses *</label>

            <Select
              mode="multiple"
              name="courseIds"
              value={values.courseIds}
              onChange={(val) => setFieldValue("courseIds", val)}  // ✅ Correct
              options={CourseData?.map((c) => ({
                value: c._id,   // ✅ only send course ID to backend
                label: c.title,
              }))}
              placeholder="Select course(s)"
              style={{ width: "100%" }}
            />

            {touched.courseIds && errors.courseIds && (
              <p className="text-red-500 text-sm">{errors.courseIds}</p>
            )}
          </div>


          <div>
            <label className="text-sm font-medium text-foreground">Name</label>
            <input name="name" value={values.name} onChange={handleChange} placeholder="Name" className="w-full px-4 py-2 border border-border rounded-xl" />
            {touched.name && errors.name && <div className="text-red-500 text-sm">{errors.name}</div>}
          </div>
          <div>
            <label className="text-sm font-medium text-foreground">Subtitle</label>
            <input name="subTitle" value={values.subTitle} onChange={handleChange} placeholder="Subtitle" className="w-full px-4 py-2 border border-border rounded-xl" />
            {touched.subTitle && errors.subTitle && <div className="text-red-500 text-sm">{errors.subTitle}</div>}
          </div>
          <div>
            <label className="text-sm font-medium text-foreground">Total Lecture</label>
            <input name="totalLecture" type="number" value={values.totalLecture} onChange={handleChange} placeholder="Total Lecture" className="w-full px-4 py-2 border border-border rounded-xl" />
            {touched.totalLecture && errors.totalLecture && <div className="text-red-500 text-sm">{errors.totalLecture}</div>}
          </div>
          <div>
            <label className="text-sm font-medium text-foreground">Total Test</label>
            <input name="totalTest" type="number" value={values.totalTest} onChange={handleChange} placeholder="Total Test" className="w-full px-4 py-2 border border-border rounded-xl" />
            {touched.totalTest && errors.totalTest && <div className="text-red-500 text-sm">{errors.totalTest}</div>}
          </div>
          <div>
            <label className="text-sm font-medium text-foreground">Priority</label>
            <input type="number" name="priority" placeholder="0" className="w-full px-4 py-2 border border-border rounded-xl" value={values.priority} onChange={handleChange} />
            {touched.priority && errors.priority && <div className="text-red-500 text-sm">{errors.priority}</div>}
          </div>
          <div>
            <label className="text-sm font-medium text-foreground">Image</label>
            <input type="file" onChange={handleImageChange} className="md:col-span-2 border p-2 rounded-xl" />
            {touched.image && errors.image && <div className="text-red-500 text-sm">{errors.image}</div>}

            {preview && <img src={preview} alt="preview" className="w-24 h-24 rounded-xl border mt-2" />}
          </div>
          <div>
            <label className="text-sm font-medium text-foreground">Link</label>
            <input name="link" value={values.link} onChange={handleChange} placeholder="Link" className="w-full px-4 py-2 border border-border rounded-xl md:col-span-2" />
          </div>

          <div className="md:col-span-2 flex justify-center">
            <button type="submit" className="w-full sm:w-[250px] min-h-[50px] text-white bg-primary font-semibold rounded-xl hover:bg-accent mt-7">
              {loading ? "Saving..." : "Save"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ModuleForm;
